/**
 * product
 */
'use strict';
import AppVue from './_modules/other/product_vue';

window.st50Modules = [];

document.addEventListener('DOMContentLoaded', () => {
  new AppVue();
}, false);

window.addEventListener('load', () => {
  //document.getElementById('c-wrapper').style.visibility = 'visible';
}, false);

window.addEventListener('unload', () => {}, false);
